// extracted by mini-css-extract-plugin
module.exports = {"page":"create_page__2PiKh","form":"create_form__uEVqK","contentLabel":"create_contentLabel__31onZ","scopeSelect":"create_scopeSelect__1d-8R"};